export const FirebaseConfig = {
  apiKey: "AIzaSyBFxJVXO3CElGQAFQPfiIgxYneyI8DoJAQ",
  authDomain: "ambulancia-app.firebaseapp.com",
  databaseURL: "https://ambulancia-app-default-rtdb.firebaseio.com",
  projectId: "ambulancia-app",
  storageBucket: "ambulancia-app.appspot.com",
  messagingSenderId: "535768542675",
  appId: "1:535768542675:web:271dfab95a3b17ff49d326",
  measurementId: "G-VZPSH0B5G3"
};

export const google_map_key = 'AIzaSyCaK8Ft2Cu6wMxm2ec4rkGa5wkvTrpPk5Y';